var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back"},[_c('div',{staticClass:"iconfont",on:{"click":_vm.back}},[_vm._v("")]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"btn"},[(_vm.useBtn)?_c('div',{staticClass:"btn-inner",on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.L(`完成`)))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }